import React, {useMemo, useRef} from "react";
import {Divider, Typography} from 'antd';

const {Text} = Typography;
import {useTalentTeam} from "../../providers/TalentTeamProvider";
import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import LoadingBanner from "../../components/LoadingBanner";
import Form, {FormInputComponent} from "../../components/form/Form";
import ReactDOM from "react-dom";
import PageNotAllowed from "../../components/errors/PageNotAllowed";

const TalentTeamNew = () => {

    const {auth} = useAuth();

    const navigate = useNavigate();
    const location = useLocation()

    const formRef = useRef();

    const {
        team,
        isLoading,
        updateTeamDetails,
        createTeam,
        isUpdating,
        onModelChange,
        resetModel
    } = useTalentTeam();

    const teamType = useMemo(() => {
        if (auth.canManageTalent()) {
            return 'talent';
        }
        return auth?.canManageClientResourceTalent() ? 'supplier' : 'talent'
    }, [auth]);

    const onCancel = async () => {
        if (!isUpdating) {
            return navigate(`/${teamType}/teams/all`, {replace: true})
        }
    }
    const onSubmit = async () => {
        if (formRef?.current) {
            let invalid = formRef.current.forceValidate();

            if (invalid) {
                const node = ReactDOM.findDOMNode(invalid);
                return $('html, body').animate({scrollTop: $(node).offset().top - 50}, 800);
            }
        }
        const newTeam = await createTeam({})
        if (newTeam?.id) {
            return navigate(
                location.pathname.replace('new', `${newTeam.id}/project-types`),
                {replace: true}
            )
        }
    }

    if (auth?.isTalentSupplierResource()) {
        return <PageNotAllowed />
    }
    if (isLoading || !team) {
        return <LoadingBanner message="Loading" adjustOverlay/>;
    }
    return (
        <div className="talent-application-container team-application-container">
            <div className="talent-application-form-container flex-col">
                <div className="p-2 md:px-4 md:py-10 flex flex-col justify-center">

                    <div className="px-4 py-8 bg-white max-w-4xl m-auto lg:p-12 flex flex-col gap-3">
                        <div>
                            <h1 className="text-2xl font-bold whitespace-no-wrap text-center mb-2">
                                Setup Your Wripple Talent Team
                            </h1>
                            <div>
                                <Divider orientation="center" plain>
                                    Overview
                                </Divider>
                            </div>
                        </div>
                        <div>

                            <div className="flex flex-col-reverse md:flex-row items-stretch md:items-center gap-8 md:gap-4">
                                <div className="basis-full md:basis-3/5 flex flex-col gap-5 justify-center">
                                    <h3 className="text-primary text-lg mb-1.5">
                                        4 Steps to Creating Your Wripple Team
                                    </h3>

                                    <p className="text-wripplePrimaryDarkNavy text-xs">
                                        From our services catalog, define the type of projects your team wants to work on
                                    </p>

                                    <p className="text-wripplePrimaryDarkNavy text-xs">
                                        Create your team roster by inviting or adding team members
                                    </p>
                                    <p className="text-wripplePrimaryDarkNavy text-xs">
                                        Create your team bio and profile
                                    </p>
                                    <p className="text-wripplePrimaryDarkNavy text-xs">
                                        Use the <span className="font-semibold">Team Control Center</span> to activate
                                        your team, manage team members, fill positions and get help
                                    </p>

                                </div>
                                <div className="px-5 basis-full md:basis-2/5">
                                    <img src="/images/heads.png" className="w-full max-w-[400px] mx-auto" alt=""/>
                                </div>
                            </div>
                        </div>

                        <hr className="mb-10"/>

                        <h5 className="text-base font-semibold mb-3">
                            Let's get started by giving your team a unique name
                        </h5>


                        <div className="talent-role-form setup-team-form">
                            <Form
                                ref={formRef}
                                title={null}
                                subtitle={null}
                                showRequired
                                submitButton={false}
                                onChange={(model) => onModelChange({...team, ...model})}
                                model={team}
                                fields={[]}
                                isDisabled={false}>

                                <div className="flex flex-col items-stretch">
                                    <div className="field-section flex-row items-start">
                                        <div className="field px-0 basis-10/12">
                                            <FormInputComponent
                                                fieldName="name"
                                                type="text"
                                                label="Team Name"
                                                value={team?.name || ""}
                                                minLength={5}
                                                maxLength={50}
                                                validation={{
                                                    rules: {
                                                        maxLength: 50,
                                                        minLength: 5
                                                    },
                                                    errors: {
                                                        maxLength: TB.trans('validation.max.string', {
                                                            'attribute': 'Team Name',
                                                            'max': 50
                                                        }),
                                                        minLength: TB.trans('validation.min.string', {
                                                            'attribute': 'Team Name',
                                                            'min': 5
                                                        })
                                                    }
                                                }}
                                                required={true}
                                                placeholder="Enter name here..."
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>

                        <div className="flex-grow flex flex-row items-center justify-end gap-4 mt-5">
                            <button className="btn btn-outline-dark btn-outline-white" onClick={onCancel}
                                    disabled={isUpdating}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={onSubmit}
                                    disabled={isUpdating}>
                                Next: Select Project Types
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TalentTeamNew;